<template>
    <footer class="footer">
        <div class="container-fluid d-flex flex-wrap justify-content-between">
            <nav>
                <ul>
                    <li>
                        <a
                            href="https://support.missingink.com"
                            target="_blank"
                        >
                            <i class="ti-help-alt"></i> Support</a>
                    </li>
                </ul>
            </nav>
            <div class="copyright d-flex flex-wrap">
                &copy; Missingink {{ new Date().getFullYear() }}
            </div>
        </div>
    </footer>
</template>

<script>
export default {};
</script>
<style></style>
